import { ChartPie, GaugeIcon, History } from "assets/Icon";
import { Box, Container, Grid, IconButton, styled, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import ButtonAction from "./Component/ButtonAction";
import CardSkeleton from "components/Skeletons/Card.Skeleton";
import ChartMargin from "./Component/ChartMargin";
import { GetMarginWalletInfo } from "store/api/wallet";
import HeaderWallet from "./Component/HeaderWallet";
import MarginCard from "./Component/Widgets/MarginCard";
import TableMargin from "./Component/TableWallet/TableMargin";
import WalletTabs from "./Component/WalletTabs";
import http from "config/http";
import useIsMobileView from "hooks/useIsMobileView";
import useNotify from "hooks/useNotify";
import { useSearchParams } from "react-router-dom";
import BottomDrawer from "components/BottomDrawer";
import { EyeIcon, EyeOffIcon } from "assets/Icon";

const actionItems = [
  {
    value: "borrow",
    text: "Borrow",
  },
  { value: "repay", text: "Repay" },
  {
    value: {
      key: "transfer",
      extra: { transferSideId: 1 },
    },
    text: "Transfer",
  },
];

export function MarginWallet() {
  const isMobileView = useIsMobileView();
  const notify = useNotify();
  const theme = useTheme();

  const itemHeader = [
    {
      link: "/portfolio",
      icon: <ChartPie color={theme.palette.secondary.main} stroke={3} />,
    },
    {
      link: "/wallet/margin-history",
      icon: <History color={theme.palette.secondary.main} />,
    },
  ];

  const [searchParams, setSearchParams] = useSearchParams();
  const transfer = searchParams.get("transfer");
  const borrow = searchParams.get("borrow");
  const repay = searchParams.get("repay");

  const [marginWalletData, setMarginWalletData] = useState();
  const [showChart, setShowChart] = useState(isMobileView ? false : true)
  const [showPrice, setShowPrice] = useState(false)

  const getMarginWalletInfo = async () => {
    try {
      const { data } = await http.get(GetMarginWalletInfo);

      setMarginWalletData(data?.data);
    } catch (e) {
      notify(e?.response?.data?.message, "error");
    }
  };

  const handleClickOnItems = (page) => {
    const defaultCoin = 1;
    setSearchParams({ [page?.key || page]: defaultCoin, ...page?.extra });
  };

  const handleSetShowPrice = () => {
    localStorage.setItem('show-margin-wallet', !showPrice)
    setShowPrice(!showPrice)
  }


  useEffect(() => {
    const currentShowPrice = localStorage.getItem('show-margin-wallet')
    if (currentShowPrice) {
      setShowPrice(JSON.parse(currentShowPrice));
    }

    getMarginWalletInfo();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transfer, repay, borrow]);

  return (
    <Container maxWidth="100%">
      <Box borderBottom={"1px solid"} borderColor={"modules.divider"} pb={4} width={"100%"}>
        <Box pl={{ xs: 0, md: 4 }} width={"100%"}>
          <Grid container mt={2}>
            {isMobileView && <WalletTabs />}

            <Grid item md={6} xs={12} display={{ xs: "none", md: "block" }} order={{ md: 1 }}>
              <TypographyTitle
                variant="h3"
                color="common.white"
                fontWeight={600}
                marginBottom={4}
              >
                Margin Wallet
              </TypographyTitle>
            </Grid>


            <Grid item md={6} xs={12} order={{ xs: 6, md: 2 }}>
              <ButtonAction
                items={actionItems}
                onChange={handleClickOnItems}
                justifyContent={{ xs: "center", md: "end" }}
              />
            </Grid>

            <Grid item xs={8} md={4} order={{ xs: 1, md: 3 }}>
              {marginWalletData ? (
                <MarginCard
                  title="Total Value Balance"
                  usdt={marginWalletData?.totalBalanceUSDT}
                  toman={marginWalletData?.totalBalanceToman}
                  showPrice={showPrice}
                >
                  <IconButton onClick={() => handleSetShowPrice()}>
                    {showPrice ? <EyeOffIcon color={theme.palette.text.primary} /> : <EyeIcon color={theme.palette.text.primary} />}
                  </IconButton>
                </MarginCard>
              ) : (
                <CardSkeleton heightSize={153} />
              )}
            </Grid>

            <Grid item xs={12} md={4} order={{ xs: 5, md: 4 }} textAlign={"left"}>
              {!isMobileView &&
                <ChartMargin marginWalletData={marginWalletData} />
              }
            </Grid>

            <Grid item xs={4} md={4} order={{ xs: 2, md: 5 }}>
              <HeaderWallet itemHeader={itemHeader} my={0} />
            </Grid>

            <Grid item xs={12} md={4} order={{ xs: 3, md: 6 }}>
              {marginWalletData ? (
                <MarginCard
                  title="Debit"
                  usdt={marginWalletData?.debtUSDT}
                  toman={marginWalletData?.debtToman}
                  showPrice={showPrice}
                >
                  {isMobileView &&
                    <IconButton onClick={() => setShowChart((v) => !v)}>
                      <GaugeIcon color={theme.palette.secondary.main} />
                    </IconButton>
                  }
                </MarginCard>
              ) : (
                <CardSkeleton heightSize={153} />
              )}
            </Grid>

            <Grid item xs={12} md={4} order={{ xs: 4, md: 7 }}>
              {marginWalletData ? (
                <MarginCard
                  title="Equity"
                  usdt={marginWalletData?.equityUSDT}
                  toman={marginWalletData?.equityToman}
                  showPrice={showPrice}
                />
              ) : (
                <CardSkeleton heightSize={153} />
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Grid container mt={4}>
        <Grid item xs={12}>
          <TableMargin />
        </Grid>
      </Grid>

      {(isMobileView && showChart) ? (
        <BottomDrawer open={showChart} onClose={() => setShowChart(false)}>
          <ChartMargin marginWalletData={marginWalletData} />
        </BottomDrawer>
      ) : null}
    </Container>
  );
}

const TypographyTitle = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));
export default MarginWallet;
